'use strict';

export function UserResource($resource) {
  'ngInject';
  return $resource('/api/users/:id/:controller', {
    id: '@_id'
  }, {
      changePassword: {
        method: 'PUT',
        params: {
          controller: 'password'
        }
      },
      role: {
        method: 'PUT',
        params: {
          controller: 'role'
        }
      },
      get: {
        method: 'GET',
        params: {
          id: 'me'
        }
      },
      shops: {
        method: 'GET',
        params: {
          id: 'shops'
        },
        isArray: true
      }
    });
}



// WEBPACK FOOTER //
// ./client/components/auth/user.service.ts